import { createSelector } from "reselect"
import { get, chain, map, forEach, find, keyBy } from "lodash"
import { getMustAggregateFactors, getStyleExposureAggregation } from "modules/portfolio-root/selectors/portfolios"
import { aggregateExposuresFactors } from "helpers/factorClassification/index"
import { getModelCategories, getModelFactors, getModelFactorsClassification } from "selectors/modelMetadata"
import { getTopFactor } from "selectors/factors"

const EMPTY_ARRAY = []
const EMPTY_OBJECT = {}

const getUserSelectedMetric = state => get(state, "modules.compareFactorSensitivity.selectedMetric")
const getSavedMetric = (_, props) => get(props, "savedMetric")

export const getFactors = createSelector(
  [getModelFactors, getMustAggregateFactors, getStyleExposureAggregation, getModelFactorsClassification],
  (factorsMetadata, mustAggregateFactors, styleAggregation, factorsClassification) => {
    if (!mustAggregateFactors) {
      return factorsMetadata
    }

    const factors = aggregateExposuresFactors(factorsClassification, factorsMetadata, styleAggregation)
    return keyBy(factors, "id")
  },
)

export const getMetrics = createSelector(
  [getFactors, getModelCategories],
  (factors, categories) => map(categories, category => ({
    label: category.label,
    options: chain(factors)
      .pickBy(factor => factor.category === category.id)
      .map((factor, id) => ({
        label: factor.label,
        id,
        value: item => chain(item)
          .get("factors", EMPTY_ARRAY)
          .find(factor => factor.id === id)
          .get("value", 0)
          .value(),
      }))
      .value(),
  })),
)

export const getSelectedMetric = createSelector(
  [getMetrics, getUserSelectedMetric, getSavedMetric, getTopFactor],
  (metrics, selectedMetric, savedMetric, topFactor) => {
    let metricData = null

    const metric = selectedMetric || savedMetric || topFactor

    forEach(metrics, item => {
      const data = find(item.options, { id: metric })

      if (data) {
        metricData = data
        return false
      }
    })

    if (!metricData) {
      metricData = get(metrics, "0.options.0", EMPTY_OBJECT)
    }
    return metricData
  },
)
